import { defineStore } from 'pinia';

interface IStore {
  loading: boolean;
}

export const useStore = defineStore({
  id: 'store',

  state: () => ({
    loading: false
  } as IStore),

  actions: {
    setLoader(): void {
      this.loading = true;
    },
    unsetLoader(): void {
      this.loading = false;
    }
  }
});
